@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $checkout-host-display;
}

.checkout {
  display: $checkout-display;
  grid-template-columns: $checkout-grid-template-columns;
  grid-template-areas: $checkout-grid-template-areas;
  width: $checkout-width;
  max-width: $checkout-max-width;
  padding: $checkout-padding;
  border: $checkout-border;
  background-color: $checkout-background-color;
  .edit {
    color: $checkout-edit-color;
    text-decoration: $checkout-edit-text-decoration;
    &:hover {
      color: $checkout-edit-hover-color;
    }
    &:focus {
      color: $checkout-edit-focus-color;
    }
    &:active {
      color: $checkout-edit-active-color;
    }
    &:visited {
      color: $checkout-edit-visited-color;
    }
  }
  .logo {
    grid-area: logo;
  }
  .name {
    grid-area: name;
    color: $checkout-name-color;
    font-family: $checkout-name-font-family;
    font-size: $checkout-name-font-size;
    font-weight: $checkout-name-font-weight;
    line-height: $checkout-name-line-height;
    padding-left: $checkout-name-padding-left;
    padding-right: $checkout-name-padding-right;
    margin-top: $checkout-name-margin-top;
    margin-bottom: $checkout-name-margin-bottom;
  }
  .title {
    grid-area: title;
    color: $checkout-title-color;
    font-family: $checkout-title-font-family;
    font-size: $checkout-title-font-size;
    font-weight: $checkout-title-font-weight;
    line-height: $checkout-title-line-height;
    padding-left: $checkout-title-padding-left;
    padding-right: $checkout-title-padding-right;
    margin-top: $checkout-title-margin-top;
    margin-bottom: $checkout-title-margin-bottom;
  }
  .payment {
    display: flex;
    justify-content: space-between;
    grid-area: payment;
  }
  .purchase {
    display: flex;
    justify-content: space-between;
    grid-area: purchase;
  }
  .divider {
    grid-area: divider;
    --air-divider-margin: #{$checkout-divider-margin};
  }
  .cost {
    display: flex;
    justify-content: space-between;
    grid-area: cost;
  }
  .fee {
    display: flex;
    justify-content: space-between;
    grid-area: fee;
  }
  .total {
    display: flex;
    justify-content: space-between;
    grid-area: total;
  }
  p {
    color: $checkout-paragraph-color;
    font-family: $checkout-paragraph-font-family;
    font-size: $checkout-paragraph-font-size;
    font-weight: $checkout-paragraph-font-weight;
    line-height: $checkout-paragraph-line-height;
    margin-top: $checkout-paragraph-margin-top;
    margin-bottom: $checkout-paragraph-margin-bottom;
    text-transform: $checkout-paragraph-text-transform;
    & + p {
      margin-top: $checkout-paragraph-divider-margin-top;
      padding-top: $checkout-paragraph-divider-padding-top;
      border-top: $checkout-paragraph-divider-border-top;
    }
    &:last-of-type {
      font-weight: $checkout-paragraph-total-font-weight;
    }
  }
  @media (max-width: $breakpoint-mobile) {
    grid-template-areas: $mobile-checkout-grid-template-areas;
    padding: $mobile-checkout-padding;
    .divider {
      --air-divider-margin: #{$mobile-checkout-divider-margin};
    }
    p {
      &:first-of-type {
        padding-top: $mobile-checkout-paragraph-divider-padding-top;
      }
    }
  }
}
